import { SatisfactionCallbackResponse } from 'core_main/api/satisfaction/types';
import { Included, IncludedTemplate } from 'core_main/pubnub/types';
import { createMessageCallbackResponse } from '../send_message/helpers';
import { HistoricalMessagesListMessage } from './types';
import { MessageCallbackResponse } from '../send_message/types';
import { GetMessagesCallbackResponse } from '../get_messages/types';

export const getIncludedFromMessage = (message): Included[] => {
  const included: Included[] = [];
  if (message.attributes?.meta?.template) {
    included.push({
      attributes: message.attributes?.meta?.template,
      type: 'template',
    } as IncludedTemplate);
  }
  message.attributes?.meta?.template?.articles?.forEach((article) =>
    included.push({
      ...article,
      type: 'article',
    }),
  );
  return included;
};
export const createGetHistoricalMessagesCallbackResponse = (
  messages: HistoricalMessagesListMessage[],
  sessionId,
): GetMessagesCallbackResponse => {
  let history = {
    satisfaction: {} as SatisfactionCallbackResponse,
    messages: [] as MessageCallbackResponse[],
  };

  if (messages?.length) {
    history = messages.reduce((acc, data) => {
      if (data.message.type === 'chat_message') {
        acc.messages.push(
          createMessageCallbackResponse(
            data.message,
            data?.attachments?.data,
            getIncludedFromMessage(data.message),
            'historical',
          ),
        );
      }

      // TODO: what about CSAT?

      return acc;
    }, history);
  }

  return {
    conversationId: sessionId,
    ...history,
  };
};
